// src/context/DeferredPromptContext.js
import React, { createContext, useState, useEffect } from 'react';

export const DeferredPromptContext = createContext();

export const DeferredPromptProvider = ({ children }) => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handleBeforeInstallPrompt = (event) => {
            event.preventDefault();
            setDeferredPrompt(event);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    return (
        <DeferredPromptContext.Provider value={{ deferredPrompt, setDeferredPrompt }}>
            {children}
        </DeferredPromptContext.Provider>
    );
};
